module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "100vh",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "container wrapper",
    staticStyle: {
      "padding": "2em"
    }
  }, [(_vm.reset_password) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    attrs: {
      "id": "forgot"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Reset your Password")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password1",
      "type": "password",
      "title": "Enter password",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.new_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirm_password),
      expression: "user.confirm_password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "password2",
      "type": "password",
      "title": "Enter password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.user.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirm_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.showPassword
    }
  }), _vm._v("Show Password\r\n                          ")])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-login",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForgotPassword
    }
  }, [_vm._v("Reset Password")])])])])])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "5em",
      "border-radius": "2px",
      "min-height": "500px"
    }
  }, [_c('div', {}, [(_vm.set_forgot_password) ? _c('div', {
    attrs: {
      "id": "forgot"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Forgot Password ?")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("reset your password")]), _vm._v(" "), (_vm.set_cta) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]) : _vm._e(), _vm._v(" "), (!_vm.set_cta) ? _c('div', [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Please provide your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-login",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Have you remembered your Password?")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("Login Here")])])]) : _vm._e(), _vm._v(" "), (_vm.set_cta) ? _c('div', {
    staticClass: "cta_balloon"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("but first check your mail")])]) : _vm._e()]) : _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Log into your account")]), _vm._v(" "), _c('form', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-email",
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "my-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "id": "my-password",
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-login",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login Now")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('forgot', '')
      }
    }
  }, [_vm._v("Forgot Password?")]), _vm._m(2)])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "intro-texts"
  }, [_c('h1', {
    staticStyle: {
      "color": "#524f4f"
    }
  }, [_vm._v("Welcome . ")]), _vm._v(" "), _c('p', [_vm._v("Login to your Buypoint Account with Eeshhbeauty to enjoy easy browsing, seaching and Shopping on the Gallery.\r\n                  Your Account provides you with easy Cart Management, Checkout Processes, Ordering and Payment Flexible Options, to\r\n                  make your Gallery Experience exciting. "), _c('br'), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(" Don't have an Account yet? "), _c('a', {
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Get One")]), _vm._v(".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Continue viewing Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(" or "), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Register?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60be4bbb"}!./src/pages/Login/template.html
// module id = 199
// module chunks = 1